import { useIsDRMUser } from './useIsDRMUser';
import { useIsInternalSearcher } from './useIsInternalSearcher';
import { useIsReviewerUser } from './useIsReviewerUser';

export function useCanSeeEntityLinks(): boolean {
  const isDRMUser = useIsDRMUser();
  const isReviewerUser = useIsReviewerUser();
  const isInternalSearcher = useIsInternalSearcher();

  const canSeeEntityLinks = (isReviewerUser || isInternalSearcher) && isDRMUser;
  return canSeeEntityLinks;
}
